function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M12 4c2.252 0 4 1.438 4 4v2.057c0 1.316-.426 2.542-1.133 3.444v.405c0 .243.01.294.056.356.154.206.606.444 1.503.65 1.737.404 3.093 1.911 3.548 3.86.137.589-.273 1.153-.855 1.221L19 20H5c-.607 0-1.074-.536-.99-1.137.265-1.92 1.502-3.479 3.151-3.909l.192-.044c1.426-.312 1.75-.59 1.778-.95l.002-.054v-.365C8.425 12.66 8 11.453 8 10.143V8.086C8 5.522 9.77 4 12 4zm-1.039 10.838l-.036.087c-.403.893-1.407 1.56-3.16 1.942-.532.108-1.015.484-1.347 1.034L6.36 18h11.143l-.075-.112c-.346-.478-.794-.822-1.288-.98l-.166-.047c-1.314-.303-2.17-.753-2.654-1.403-.158-.21-.263-.406-.333-.61-.313.1-.644.152-.988.152-.362 0-.71-.056-1.039-.162zM12 6c-1.187 0-2 .699-2 2.086v2.057c0 1.63.958 2.857 2 2.857.364 0 .723-.164 1.034-.45.06-.094.137-.176.226-.244.441-.534.74-1.337.74-2.249V8c0-1.362-.776-2-2-2z"
});

var SvgUser = function SvgUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user.dda8813d.svg";
export { ForwardRef as ReactComponent };